import App from "App";
import AOS from "aos";
import CookiesPolicy from "default-consent/CookiesPolicy";
import About from "./components/about/About";
import Header from "./components/header/Header";
import WhatsAppButton from "./components/floating-whatsapp-button/FloatingWhatsAppButton";
import DefaultConsent from "default-consent/DefaultConsent";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import ScrollToTop from "ScrollToTop";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import Contact from "./components/contact/Contact";
import RequestQuote from "./components/request-quote/RequestQuote";
import WorkWithUs from "./components/work-with-us/WorkWithUs";
import Blog from "./components/blog/Blog";
import BlogPost from "./components/blog-posts/BlogPost";
import {
  MassagensTerapiasIndividuais,
  YogaLaboralAtividadesEmGrupo,
  AtendimentoOnlineHomeOffice,
  WorkshopsPalestrasCorporativas,
  QuickMassageEventosCorporativos,
  RelatoriosGestaoPrograma,
} from "./components/solutions";

const MainLayout = () => (
  <div className="app">
    <Header />
    <main className="content">
      <Outlet />
      <Contact />
    </main>
    <WhatsAppButton />
    <DefaultConsent />
  </div>
);

const AppRoutes = () => {
  const isMobile = window.innerWidth < 768; // breakpoint mobile

  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 768,
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <ToastContainer
        position={isMobile ? "bottom-center" : "top-center"}
        autoClose={4000}
      />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<App />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/talk" element={<RequestQuote />} />
          <Route path="/work-with-us" element={<WorkWithUs />} />
          <Route path="/solutions/massagens-terapias-individuais" element={<MassagensTerapiasIndividuais />} />
          <Route path="/solutions/yoga-laboral-atividades-grupo" element={<YogaLaboralAtividadesEmGrupo />} />
          <Route path="/solutions/atendimento-online-home-office" element={<AtendimentoOnlineHomeOffice />} />
          <Route path="/solutions/workshops-palestras-corporativas" element={<WorkshopsPalestrasCorporativas />} />
          <Route path="/solutions/quick-massage-eventos-corporativos" element={<QuickMassageEventosCorporativos />} />
          <Route path="/solutions/relatorios-gestao-programa" element={<RelatoriosGestaoPrograma />} />
        </Route>
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
